import '../Inscription.less';
import {Avatar, Menu, Dropdown, Tooltip} from 'antd';
import { ApartmentOutlined,EyeOutlined, HomeOutlined,FileTextOutlined, TeamOutlined, UserOutlined, LogoutOutlined,UnorderedListOutlined } from '@ant-design/icons';
import React, { Component } from "react";
import cabezal from '../Cabezal.jpg'
import {NavLink} from "react-router-dom";
import { NavItem } from './NavItem';
import i18next from 'i18next';
import { withTranslation  } from 'react-i18next';
import moment from 'moment';
import {logout,centerStyle} from './utils';
import esFlag from '../es.png'
import enFlag from '../uk.png'
import frFlag from '../fr.png'

/** *
* *Menu used in all Admin Views, the only variable is the reports menu, that receives as a param
*/const PREFERENCES_KEY = "FI_Preferences";

  

   
  const MenuItem = Menu.Item;
class LangSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: 'en',
    }
    this.onChangeLanguage = this.onChangeLanguage.bind(this);
    this.getBrowserLanguage = this.getBrowserLanguage.bind(this);
    this.configureLanguage = this.configureLanguage.bind(this);
  }
  languages = [
    { key: 'en', value: 'Inglés', flag: enFlag },
    { key: 'es', value: 'Español', flag: esFlag },
    // { key: 'fr', value: 'Francés', flag: frFlag },
  ]
  current(){
    if (this.preferences) {
        return Promise.resolve(this.preferences);
    }
    var rawPreferences = window.localStorage.getItem(PREFERENCES_KEY);
    if (rawPreferences) {
        this.preferences = JSON.parse(rawPreferences )  ;
    } else {
        this.preferences = {
            currentCompany: undefined,
            currentLanguage: this.getBrowserLanguage()
        };
    }
    return Promise.resolve(this.preferences);
}

 async setCurrentLanguage(language) {
    var preferences = await this.current();
    preferences.currentLanguage = language;
    await this.savePreferences(preferences);
    return preferences;
}

 async savePreferences(preferences) {
    window.localStorage.setItem(PREFERENCES_KEY, JSON.stringify(this.preferences));
    return preferences;
}

 getBrowserLanguage() {
    var supportedLangs = this.languages.map(o => o.key);
    var language = window.navigator.language || (window.navigator ).userLanguage || supportedLangs[0];
    supportedLangs.forEach(lang => {
        if (language && language == lang || language.startsWith(lang))
            language = lang;
    });
    return language || supportedLangs[0];
}


  componentWillMount() {
      this.current().then(prefs => {
        if (prefs && prefs.currentLanguage) {
          this.configureLanguage(prefs.currentLanguage);
        } else {
          this.configureLanguage(this.getBrowserLanguage());
        }
      }).catch(error => {
        this.configureLanguage(this.getBrowserLanguage());
      });
    }


 configureLanguage(language) {
    moment.locale(language);
    i18next.changeLanguage(language);
    this.setState({ language: language });
  }

   onChangeLanguage(value) {

    this.setCurrentLanguage(value.key);
    this.configureLanguage(value.key);
  }
  
  
  render() {  
    const { SubMenu } = Menu;
   
    const t = this.props.t

    if (!this.state.language)
      return <div></div>;
    var languages = this.languages.filter(x => !this.props.languages || this.props.languages.includes(x.key));
    var currentLanguages = languages.filter(o => o.key == this.state.language);
    if (currentLanguages.length == 0)
      currentLanguages = languages
    var currentLanguage = currentLanguages[0];
    return <NavItem title={t(currentLanguage.value)}
      icon={<Avatar size={this.props.isMobileOrTablet ? "small" : "default"} shape="square" src={currentLanguage.flag} />}
      subMenu={<Menu onClick={this.onChangeLanguage}>
        {languages.map(lang => <MenuItem key={lang.key}>
          <Avatar size="default" shape="square" src={lang.flag} />
          <span style={{ marginLeft: 10 }}>{t(lang.value)}</span>
        </MenuItem>
        )}
      </Menu>}>
    </NavItem>
  }
}
export default withTranslation()(LangSelect);


